import { apiHelper } from "./api_helper";

export const userApi = {
    SelectTuVanVien: (dm_coso_id) => apiHelper.get(`user/tu-van-vien/${dm_coso_id}`),
    Detail: (id) => apiHelper.get(`user/${id}`),
    SelectAll: () => apiHelper.get('user'),
    SelectUserPheDuyet: (dm_coso_id) => apiHelper.get(`user/phe-duyet/${dm_coso_id}`),
}